import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_2 = {
  key: 0,
  class: "placeholder cut"
}
const _hoisted_3 = { class: "cut" }
const _hoisted_4 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = {
  key: 0,
  class: "ui-select",
  style: {"width":"100%","border":"none","padding":"0"}
}
const _hoisted_7 = {
  key: 0,
  class: "placeholder cut"
}
const _hoisted_8 = { class: "cut" }
const _hoisted_9 = {
  key: 0,
  class: "placeholder cut"
}
const _hoisted_10 = { class: "cut" }
const _hoisted_11 = {
  key: 0,
  class: "ui-select",
  style: {"width":"100%","border":"none","padding":"0"}
}
const _hoisted_12 = {
  class: "ui-input",
  style: {"width":"100%","border-bottom":"1px solid #ccc"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_tags = _resolveComponent("tirscript3-tags")!
  const _component_tirscript3_list_view = _resolveComponent("tirscript3-list-view")!
  const _component_tirscript3_scroll = _resolveComponent("tirscript3-scroll")!
  const _component_tirscript3_box_menu = _resolveComponent("tirscript3-box-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tirscript-dropdown",
    onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
    onMouseover: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onMouseOver && _ctx.onMouseOver(...args))),
    ref: "dropdown"
  }, [
    _createElementVNode("div", {
      class: "my-class",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      (!_ctx.ShowItemsList)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.multiselect)
              ? _renderSlot(_ctx.$slots, "multiselect", {
                  key: 0,
                  SelectItems: _ctx.getSelectItems()
                }, () => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["ui-select", { 'has-error': _ctx.hasError }]),
                    style: _normalizeStyle(_ctx.styleUiSelect)
                  }, [
                    (_ctx.getSelectItems().length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.placeholder), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_tirscript3_tags, {
                      disabled: _ctx.disabled,
                      style: {"font-size":"=0.875em"},
                      Items: _ctx.getSelectItems(),
                      onClose: _ctx.onClose
                    }, null, 8, ["disabled", "Items", "onClose"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["icon1", _ctx.innerIcon])
                    }, null, 2)
                  ], 6)
                ])
              : _renderSlot(_ctx.$slots, "singleselect", {
                  key: 1,
                  SelectItems: _ctx.getSelectItems()
                }, () => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["ui-select", { transformer: _ctx.innerTransformer, 'has-error': _ctx.hasError }]),
                    style: _normalizeStyle(_ctx.styleUiSelect)
                  }, [
                    (_ctx.getSelectItems().length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getSelectText()), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["icon1", _ctx.innerIcon])
                    }, null, 2)
                  ], 6)
                ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.multiselect)
              ? _renderSlot(_ctx.$slots, "multiselectactive", {
                  key: 0,
                  SelectItems: _ctx.getSelectItems()
                }, () => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["ui-select", { 'has-error': _ctx.hasError }]),
                    style: _normalizeStyle(_ctx.styleUiSelect)
                  }, [
                    (_ctx.getSelectItems().length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_tirscript3_tags, {
                        style: {"font-size":"=0.875em"},
                        Items: _ctx.getSelectItems(),
                        onClose: _ctx.onClose
                      }, null, 8, ["Items", "onClose"])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["icon1 active", _ctx.innerIcon])
                    }, null, 2)
                  ], 6)
                ])
              : _renderSlot(_ctx.$slots, "singleselectactive", {
                  key: 1,
                  SelectItems: _ctx.getSelectItems()
                }, () => [
                  (_ctx.autocomplete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ui-select", { transformer: _ctx.innerTransformer, 'has-error': _ctx.hasError }]),
                          style: _normalizeStyle(_ctx.styleUiSelect)
                        }, [
                          (_ctx.getSelectItems().length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.placeholder), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getSelectText()), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["icon1", _ctx.innerIcon])
                          }, null, 2)
                        ], 6)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["ui-select", { transformer: _ctx.innerTransformer, 'has-error': _ctx.hasError }]),
                        style: _normalizeStyle(_ctx.styleUiSelect)
                      }, [
                        (_ctx.getSelectItems().length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.placeholder), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getSelectText()), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["icon1 active", _ctx.innerIcon])
                        }, null, 2)
                      ], 6))
                ])
          ], 64)),
      _createElementVNode("div", {
        class: _normalizeClass(["ui-options", { active: _ctx.eShowItemsList }])
      }, [
        _renderSlot(_ctx.$slots, "options", {
          items: _ctx.getInnerItems(),
          select: _ctx.onSelect
        }, () => [
          _createVNode(_component_tirscript3_box_menu, {
            class: _normalizeClass(["width100", { ms: _ctx.multiselect && _ctx.getSelectItems().length > 0 }])
          }, {
            default: _withCtx(() => [
              (_ctx.autocomplete)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        tabindex: "991",
                        class: "px-3",
                        style: {"width":"100%","border":"none"},
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autoComplete) = $event)),
                        autofocus: "true",
                        ref: "auto",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInputAutocomplete && _ctx.onInputAutocomplete(...args))),
                        onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnterAutocomplete && _ctx.onEnterAutocomplete(...args)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.autoComplete]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.scroll)
                ? (_openBlock(), _createBlock(_component_tirscript3_scroll, {
                    key: 1,
                    style: _normalizeStyle({ height: _ctx.h + 'px' })
                  }, {
                    default: _withCtx(() => [
                      (_ctx.scroll)
                        ? (_openBlock(), _createBlock(_component_tirscript3_list_view, {
                            key: 0,
                            style: _normalizeStyle({ height: _ctx.h + 'px' }),
                            items: _ctx.getInnerItems(),
                            onSelect: _ctx.onSelect,
                            multiselect: _ctx.multiselect,
                            underline: _ctx.underline
                          }, null, 8, ["style", "items", "onSelect", "multiselect", "underline"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.getInnerItems().length > 0)
                      ? (_openBlock(), _createBlock(_component_tirscript3_list_view, {
                          key: 0,
                          items: _ctx.getInnerItems(),
                          onSelect: _ctx.onSelect,
                          multiselect: _ctx.multiselect,
                          underline: _ctx.underline
                        }, null, 8, ["items", "onSelect", "multiselect", "underline"]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ], 2)
    ])
  ], 544))
}